import React from "react";
import { Card, CardBody, Col, Label, Row, Button } from 'reactstrap';
import Form from './Form'
import FormBuilder from '../Components/FormBuilder';
import ModalIncidencia from './ModalInci.js'

function IncidentInformation(props) {
	return (
		<Card className="myCard">
			<CardBody>
				<Col>
					<Row>
						<i className='fas fa-exclamation-triangle mr-2' style={{ fontSize: '1.7em', color: 'orange' }}></i>
						<Label style={{ color: 'black' }}><b>Incident Information</b></Label>
					</Row>
				</Col>
				<br />
				<Row>
					<FormBuilder
						dataForm={Form.Incident}
						Model={props.Model}
						onChange={props.onChange}
						Catalog={props.Catalog}
					/>
				</Row>
				<ModalIncidencia
					dataForm={Form.CreateIncident}
					Model={props.Model}
					Catalog={props.Catalog}
					onChange={props.onChange}
					onCancel={props.onCancel}
					CreateIncident={props.CreateIncident} />
				<Col xs={12} style={{ textAlignLast: 'center' }} hidden={props.Model['incidenttype'].value === 'Not Incident' ? true : false}>
					<Button
						color="danger"
						onClick={() => { props.DeleteIncidencia() }}
						hidden={props.flag === true ? false : true}>
						<i className='fas fa-trash-alt mr-2' />
									Delete
						</Button>
								&nbsp;
					<Button
						color="primary"
						onClick={props.DisabledUpdateInciden}
						hidden={props.flag === true ? false : true}>
						<i className='fas fa-edit mr-2' />
								Update
					</Button>
					<Button
						color="primary"
						onClick={()=>{props.UpdateIncident(); props.DisabledUpdateInciden()}}
						hidden={props.flag}
					>
						<i className='fas fa-save mr-2' />
								save
					</Button>
					&nbsp;
					&nbsp;
					<Button
						color="danger"
						onClick={props.DisabledUpdateInciden}
						hidden={props.flag}
					>
						<i className='fas fa-window-close mr-2' />
								Cancel
					</Button>
				</Col>
			</CardBody>
		</Card>
	);
}

export default IncidentInformation;